<template>
  <div v-if="contact" class="inline-grid gap-2 font-medium">
    <LinkComponent
      v-if="contact['phone-number']?.type === 'phone'"
      class="text-icon-link gap-2 text-base text-black"
      :link="contact['phone-number']"
      ><SvgIcon class="h-5 w-5" name="Phone" />
      {{ contact["phone-number"]?.label ?? contact["phone-number"]?.phone }}
    </LinkComponent>
    <div v-if="contact?.['additional-info']" class="col-span-full -mt-2 text-sm font-normal">
      {{ contact?.["additional-info"] }}
    </div>
    <LinkComponent
      v-if="contact?.email?.type === 'mail'"
      class="text-icon-link gap-2 text-base text-black"
      :link="contact?.email"
    >
      <SvgIcon class="h-5 w-5" name="Mail" />{{ contact?.email?.label ?? contact?.email?.email }}
    </LinkComponent>
  </div>
</template>

<script setup>
import LinkComponent from "~/templates/components/cms/LinkComponent.vue";
import SvgIcon from "~/templates/elements/SvgIcon.vue";

defineProps(["contact"]);
</script>
